import(/* webpackMode: "eager" */ "/app/src/app/parliament/[slug]/page.tsx");
